import { z } from "zod";

export const complaintFormSchema = z.object({
  customerId: z.string().uuid("Select a customer"),
  productName: z.string().min(1, "Product name is required"),
  brand: z.string().optional().or(z.literal("")),
  model: z.string().optional().or(z.literal("")),
  serialNumber: z.string().optional().or(z.literal("")),
  description: z.string().min(5, "Describe the issue in a bit more detail"),
  priority: z.enum(["LOW", "MEDIUM", "HIGH", "URGENT"]),
  assignedEmployeeId: z.string().uuid().optional().or(z.literal("")),
  expectedCompletionDate: z.string().optional().or(z.literal("")),
  internalNotes: z.string().max(2000).optional().or(z.literal("")),
});
export type ComplaintFormValues = z.infer<typeof complaintFormSchema>;

export const noteFormSchema = z.object({
  remarks: z.string().min(1, "Note cannot be empty").max(2000),
});
export type NoteFormValues = z.infer<typeof noteFormSchema>;

export const hoursFormSchema = z.object({
  workingHours: z.coerce.number().positive("Must be greater than 0").max(24),
  remarks: z.string().max(500).optional().or(z.literal("")),
});
export type HoursFormValues = z.infer<typeof hoursFormSchema>;
